import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ValidStaffCodeList } from './interface/valid-staff-code.interface';

/**
 * this is a calss of service that calls back end for getting staff codes
 */
@Injectable()
export class ValidStaffCodeService {
    constructor(private http: HttpClient) {}

    get(): Observable<ValidStaffCodeList> {
        return this.http.get<ValidStaffCodeList>('/api/validStaffCode', {});
    }

    getAll(): Observable<ValidStaffCodeList> {
        return this.http.get<ValidStaffCodeList>('/api/validStaffCode/all', {});
    }

    getAllEnabled(): Observable<ValidStaffCodeList> {
        return this.http.get<ValidStaffCodeList>('/api/validStaffCode/allEnabled', {});
    }

    getAllDisabled(): Observable<ValidStaffCodeList> {
        return this.http.get<ValidStaffCodeList>('/api/validStaffCode/allDisabled', {});
    }
}
